// extracted by mini-css-extract-plugin
export default {"mainContainer":"HomePage_mainContainer__DmcUh","searchField":"HomePage_searchField__cXtjy","card":"HomePage_card__sHMBl","uploadContainer":"HomePage_uploadContainer__d5cUg"};